export const RUG_SUB_LAYER_DELTA = 0.0075
export const RUG_THICKNESS = 0.0235

export const DEFAULT_MOBILE_TEXTURE_SIZE = 1024

export const SENTRY_BREADCRUMB_CATEGORY = 'graphics'

export const AA_FXAA = 1
export const AA_TAA = 2
//
// Certain furniture can behave badly when pressed flush
// against a wall. The backboard of something like
// a bookshelf can appear to embed itself inside of the
// wall, causing the user to see wall where they would
// expect to see the shelf's backboard. This is due to the
// wall's floor lines not being perfectly aligned with the
// its depth data. The cause is different but the effect
// looks something like z-fighting. See the JIRA entry
// here for an example:
//
// https://geomagical.atlassian.net/browse/GFX-500
//
// The following 5 lines of code shift walls outward by
// 0.02125 along their normals. This shift makes it so that
// you can't push a furniture item through the wall's depth
// barrier. The value 0.02125 was determined expirmentally,
// and is roughly the diameter of a penny.
//

export const WALL_SHIFT = 0.02125
export const DEFAULT_THREE_NATIVE_LAYER = 0
export const STATIC_STACKABLES_THREE_NATIVE_LAYER = 1

export const DOWNLOAD_RETRIES_COUNT = 3
export const DOWNLOAD_RETRY_DELAY_MS = 1000